import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { NotificationManager } from "react-notifications";
import { ActionContext } from "context/ActionContext";
import UserService from "services/UserService";
import {
  putAction,
  getAction,
  getProfilePicture,
  postFileUpload,
} from "services/ConfigServices";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { CustomSelect, TextInput } from "components/Input/Index.js";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import EditButton from "components/CustomButtons/EditButton";
import { action as actionVar } from "variables/action";
import defaultImage from "assets/img/image_placeholder.jpg";

export default function DetailsEdit({ apiData, params, closeModal }) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;

  const [newDetails, setNewDetails] = useState({});
  const [imageUrl, setImageUrl] = useState(null);
  const [imageCode, setImageCode] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(defaultImage);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewDetails((prevState) => ({
      ...prevState,
      [params]: { ...prevState.details, [name]: value },
    }));
  };

  useEffect(() => {
    setNewDetails(action?.parameters || {});
    let imageCode = action?.parameters?.details?.imageCode;
    if (imageCode) {
      setImageCode(imageCode);
      setImagePreviewUrl(getProfilePicture(imageCode));
    }
  }, [action]);

  //Send picture
  useEffect(() => {
    if (imageUrl) {
      const formData = new FormData();
      // we append each element to the form
      formData.append("files", imageUrl);
      axios
        .post(postFileUpload(0, "profilepic"), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          //console.log(res.data);
          //console.log(res.data.files[0].url);
          setImageCode(res.data.files[0].url);
          setImagePreviewUrl(getProfilePicture(res.data.files[0].url));
        })
        .catch(() => {});
    }
  }, [imageUrl]);

  const urlPlanAction = getAction(action.id);

  let url = putAction(action.id);

  const handleSubmit = (event) => {
    createActionDetails(event);
  };

  const createActionDetails = async (event) => {
    axios
      .put(
        url,
        {
          ...newDetails,
          details: { ...newDetails.details, imageCode },
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        console.log(res);
        if (res.status == 200) {
          setAction((prevState) => ({
            ...prevState,
            parameters: {
              ...newDetails,
              details: { ...newDetails.details, imageCode },
            },
          }));
          setNotification("success", "Détails modifiée");
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        //setLoading(false);
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const definitionData = [
    { name: "Nouvelle action", id: "new" },
    { name: "Préconisation", id: "prec" },
  ];

  return (
    <>
      {/*<GridContainer>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          <CustomSelect
            inputTitle={actionVar[params]["definition"]}
            selectValue={newDetails?.[params]?.["definition"] || ""}
            handleSelectValueChange={handleChange}
            data={definitionData}
            name="definition"
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          {newDetails?.[params]?.definition === "prec" && (
            <TextInput
              inputTitle={actionVar[params]["preconization"]}
              textInput={newDetails?.[params]?.["preconization"] || ""}
              handleTextInputChange={handleChange}
              name="preconization"
            />
          )}
        </GridItem>
          </GridContainer>*/}
      <GridContainer>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          <ImageUpload
            file={imageUrl}
            setImageCode={setImageCode}
            setFile={setImageUrl}
            imagePreviewUrl={imagePreviewUrl}
            setImagePreviewUrl={setImagePreviewUrl}
            disabled={!actionplanupdate}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextInput
            inputTitle={actionVar[params]["advantages"]}
            textInput={newDetails?.[params]?.["advantages"] || ""}
            handleTextInputChange={handleChange}
            name="advantages"
            disabled={!actionplanupdate}
          />
          <TextInput
            inputTitle={actionVar[params]["target"]}
            textInput={newDetails?.[params]?.["target"] || ""}
            handleTextInputChange={handleChange}
            name="target"
            disabled={!actionplanupdate}
          />
          <TextInput
            inputTitle={actionVar[params]["description"]}
            textInput={newDetails?.[params]?.["description"] || ""}
            handleTextInputChange={handleChange}
            name="description"
            multiline
            rows={4}
            disabled={!actionplanupdate}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextInput
            inputTitle={actionVar[params]["disadvantages"]}
            textInput={newDetails?.[params]?.["disadvantages"] || ""}
            handleTextInputChange={handleChange}
            name="disadvantages"
            disabled={!actionplanupdate}
          />
          <TextInput
            inputTitle={actionVar[params]["implemenation"]}
            textInput={newDetails?.[params]?.["implemenation"] || ""}
            handleTextInputChange={handleChange}
            name="implemenation"
            disabled={!actionplanupdate}
          />
          <TextInput
            inputTitle={actionVar[params]["regulation"]}
            textInput={newDetails?.[params]?.["regulation"] || ""}
            handleTextInputChange={handleChange}
            name="regulation"
            disabled={!actionplanupdate}
          />
        </GridItem>
      </GridContainer>
      {actionplanupdate && (
        <GridContainer>
          <GridItem
            xs={12}
            sm={12}
            md={7}
            lg={7}
            style={{ marginLeft: "8px", marginTop: "12px" }}
          >
            <EditButton handleSubmit={handleSubmit}>Modifier</EditButton>
          </GridItem>
        </GridContainer>
      )}
    </>
  );
}
